import React from 'react';
import { Card } from '../../../components/ui/Card/Card';
import { Icon } from '../../../components/ui/Icon/Icon';
import { responseTips } from '../../../entities/support/model/constants';
import styles from './TipsCard.module.scss';

export function TipsCard() {
  return (
    <Card title="Что ускорит ответ" icon="bulb">
      <ul className={styles.tips}>
        {responseTips.map((tip) => (
          <li key={tip.strong}>
            <Icon name="check" size={13} strokeWidth={2.2} />
            <span>
              <b>{tip.strong}</b>
              {tip.rest}
            </span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
